import React from "react";
import { useCurrencyFormatter } from "../../hooks/useCurrencyFormatter";
import { MetricComponentProps } from "../../types/metrics";
import MetricItem from "./MetricItem";
import {
  formatPrincipal,
  formatTermLength,
  formatMonthlyPayment,
  getMonthlyPaymentTooltip,
} from "./metricHelpers";

export default function InterestRateSecondaryMetric({
  sim,
}: MetricComponentProps) {
  const c = useCurrencyFormatter();

  return (
    <>
      <MetricItem value={formatPrincipal(sim, c)} tooltip="Principal Amount" />
      {" • "}
      <MetricItem value={formatTermLength(sim)} tooltip="Mortgage Term" />
      {" • "}
      <MetricItem
        value={formatMonthlyPayment(sim, c)}
        tooltip={getMonthlyPaymentTooltip(sim)}
      />
    </>
  );
}
